import {
    GET_EMPLOEE_ON_HOLD_REQUEST,
    GET_EMPLOEE_ON_HOLD_SUCCESS,
    GET_EMPLOEE_ON_HOLD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getEmployeeOnHoldReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMPLOEE_ON_HOLD_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case GET_EMPLOEE_ON_HOLD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_EMPLOEE_ON_HOLD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default getEmployeeOnHoldReducer;
